import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { IVisitorTypeListProps, IVisitorTypeListItem } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const VisitorTypeList: React.FC<IVisitorTypeListProps> = ({
  visitorTypes,
}) => {
  const renderListItem = (visitorType: IVisitorTypeListItem) => (
    <tr key={visitorType.id}>
      <td>
        <Link to={`/admin/visitorTypes/${visitorType.id}`}>
          {visitorType.name}
        </Link>
      </td>
      <td>
        <FontAwesomeIcon icon={visitorType.icon} size="lg" />
      </td>
    </tr>
  );

  return (
    <Table hover>
      <thead>
        <tr>
          <th>Name</th>
          <th>Icon</th>
        </tr>
      </thead>
      <tbody>{visitorTypes.map(renderListItem)}</tbody>
    </Table>
  );
};
